<template>
  <div>
    <Display
      v-if="!edit && !staticEdit && !loading"
      :activeColumn="activeColumn"
      :masterColumn="masterColumn"
      @edit="edit=true"
    />

    <Editing
      v-if="edit || staticEdit || loading"
      :staticEdit="staticEdit"
      :staticEmptyString="staticEmptyString"
      :columnHeight="staticEdit ? '300px' : '500px'"
      :activeColumn="activeColumn"
      :masterColumn="masterColumn"
      :loading="loading"
      @cancel="edit=false"
      @save="save"
    />
  </div>
</template>

<script>
import Display from './Display.vue'
import Editing from './Editing.vue'

import FormActionButtons from '@/components/elements/FormActionButtons.vue'

export default {
  name: 'DraggableColumns',
  components: {
    Display,
    Editing,
    FormActionButtons
  },
  props: {
    activeColumn: {
      required: true,
      default: false,
    },
    masterColumn: {
      required: true,
      default: false,
    },
    loading: {
      type: Boolean,
      required: true,
      default: false
    },
    staticEdit: {
      type: Boolean,
      required: false,
      default: false
    },
    staticEmptyString: {
      type: String,
      required: false,
      default: ''
    }
  },
  data () {
    return {
      edit: false,
    }
  },
  created () { 
  },
  methods: {
    save (array) {
      this.edit = false
      this.$emit('save', array)
    }
  },
  computed: {
  }
}
</script>

<style scoped lang="scss">
</style>
